<template>
  <CChartLine :datasets="defaultDatasets" :options="defaultOptions" :labels="monthLabels" />
</template>

<script>
import { CChartLine } from '@coreui/vue-chartjs';
import { hexToRgba } from '@coreui/utils/src';
import { mapActions } from "vuex";

export default {
  name: 'MainChartExample',
  components: { CChartLine },
  data() {
    return {
      metodsPayments: [],
      dataMonth: [],
      ingresosPorMetodo: {},
      coloresMetodoPago: {
        "efectivo": '#41B883',
        "tarjeta": '#0a4d86',
        "yape": '#8527a4',
        "plin": '#08e1ca',
        "transferencia": '#DD4B18'
      },
      meses: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']
    };
  },
  created() {
    this.getData();
  },
  computed: {
    monthLabels() {
      const currentMonth = new Date().getMonth();
      const lastMonthWithData = Math.max(
        ...this.dataMonth.map(income => new Date(income.created_at).getUTCMonth())
      );
      const lastMonth = Math.max(currentMonth, lastMonthWithData);
      return this.meses.slice(0, lastMonth + 2);
    },
    defaultDatasets() {
      return this.metodsPayments.map(mp => {
        let color = this.coloresMetodoPago[mp.method_name.toLowerCase()] || '#999999';

        const data = mp.history.map(item => {
          const monthIndex = new Date(item.month + "-01").getUTCMonth();
          return {
            monthIndex,
            total: parseFloat(item.total)
          };
        });

        const filledData = Array(12).fill(0);
        data.forEach(item => {
          filledData[item.monthIndex] = item.total;
        });

        return {
          label: mp.method_name,
          backgroundColor: hexToRgba(color, 10),
          borderColor: color,
          pointHoverBackgroundColor: color,
          borderWidth: 2,
          data: filledData.slice(0, this.monthLabels.length)
        };
      });
    },
    maxYValue() {
      const maxVal = Math.max(
        ...this.metodsPayments.flatMap(mp => mp.history.map(item => parseFloat(item.total)))
      );
      return Math.ceil(maxVal * 1.1);
    },
    defaultOptions() {
      return {
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            gridLines: {
              drawOnChartArea: false
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              maxTicksLimit: 6,
              // stepSize: 150,
              stepSize: Math.ceil(this.maxYValue / 100),
              max: this.maxYValue
            },
            gridLines: {
              display: true
            }
          }]
        },
        elements: {
          point: {
            radius: 0,
            hitRadius: 10,
            hoverRadius: 4,
            hoverBorderWidth: 3
          }
        }
      }
    }
  },

  methods: {
    ...mapActions(["get", "post"]),
    getData() {
      this.get({
        url: this.$store.getters.get__url + "/beads/carbino/indexHome/" +
          this.$store.getters.get_campu.id + "/" +
          this.$store.getters.get_company.id + "/" +
          this.$store.getters.get__user_id,
        token: this.$store.getters.get__token,
      }).then((response) => {
        if (response.statusCode == 200) {
          this.metodsPayments = response.data.monthlyHistory;
        }
      });
    }
  }
}
</script>
